// `rand` defaults to Math.random so every existing caller is unchanged. World generation passes
// the seeded generator, which is what makes a pinned seed produce the same town names.
const randomizeFromList = (list, usedIndices, rand = Math.random) => {
  const len = list.length;
  let randomIndex = Math.floor(rand() * len);

  while (usedIndices.has(randomIndex) && usedIndices.size < len) {
    randomIndex = Math.floor(rand() * len);
  }

  usedIndices.add(randomIndex);
  return list[randomIndex];
};

export { randomizeFromList };
